// You can customize the theme with the help of this file

//Template config options
const themeConfig = {
  direction: 'ltr', // options[String] : ltr / rtl
  disableCustomizer: true, // options[Boolean]: true, false(default)
  footerType: 'static', // options[String]: static(default) / sticky / hidden
  hideScrollToTop: false, // options[Boolean]: true, false(default)
  layout: 'vertical', // options[String]: "vertical"(default), "horizontal"
  menuTheme: 'primary', // options[String]: primary / success / danger / info / warning / dark
  navbarColor: 'default', // options[String]: default / primary / success / danger / info / warning / dark
  navbarType: 'sticky', // options[String]: floating(default) / static / sticky / hidden
  sidebarCollapsed: false, // options[Boolean]: true, false(default)
  theme: 'light', // options[String]: 'light'(default), 'dark', 'semi-dark'
};

export default themeConfig;
